import { useEffect, useRef, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUserEditBoxHeight } from "../../../redux/slices/sellerDataUserListSlice";
import {
  CircularProgress,
  useTheme,
  Checkbox,
  Typography,
  FormControlLabel,
} from "@mui/material";

import {
  UpdateFadeBox,
  ArrowBox,
  Arrow,
  ArrowBorder,
  UpdateButtonBox,
  UpdateButton,
} from "./styles/index";

export const ApiCredentialEdit = memo((props) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const { state } = useSelector((state) => ({
    state,
  }));
  const updateContainerRef = useRef(null);

  const updateContainerHeight = () => {
    if (updateContainerRef.current) {
      const newHeight = updateContainerRef.current.clientHeight;
      dispatch(setUserEditBoxHeight(newHeight));
    }
  };

  useEffect(() => {
    updateContainerHeight();
    window.addEventListener("resize", updateContainerHeight);
    return () => {
      window.removeEventListener("resize", updateContainerHeight);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateContainerHeight();
    // eslint-disable-next-line
  }, [state.error, state.removeUserPopper]);

  useEffect(() => {
    if (props.credentials.length) {
      const activeStatus = {};
      for (const item of props.credentials) {
        activeStatus[item["credential_type_id"]] = true;
      }
      for (const item of props.credentialData) {
        if (!activeStatus.hasOwnProperty(item["credential_type_id"])) {
          activeStatus[item["credential_type_id"]] = false;
        }
      }
      const output = Object.entries(activeStatus).map(([key, value]) => ({
        credential_type_id: key,
        active: value,
      }));
      props.handleCredentialData(output, props.userId);
    } else {
      props.handleCredentialData(props.credentialData, props.userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.credentials]);

  const handleCheckboxChange = (e, idx) => {
    const res = props.credentialData.map((v, i) => {
      if (i === idx) {
        return {
          credential_type_id: e.target.value,
          active: !v.active,
        };
      } else {
        return { ...v };
      }
    });
    props.handleCredentialData(res, props.userId);
  };

  return (
    <UpdateFadeBox
      in={props.open === props.index}
      theme={theme}
      styles={props.width}
      isMobile={props.isMobile}
    >
      <ArrowBox isMobile={props.isMobile} ref={updateContainerRef} {...props}>
        <Typography fontSize={".875rem"} color={theme.greyText} mb={1}>
          Email: <strong>{props.email}</strong>
        </Typography>
        {props.credentialData.map((item, idx) => {
          return (
            <FormControlLabel
              sx={{
                display: "flex",
                mb: 1,
                "& .MuiCheckbox-root.Mui-disabled": {
                  color: theme.palette.disabledButton,
                },
              }}
              value={item.credential_type_id}
              control={
                <Checkbox
                  size="small"
                  checked={item.active}
                  onChange={(e) => handleCheckboxChange(e, idx)}
                />
              }
              label={
                <Typography fontSize={".875rem"} fontWeight={600}>
                  {item.credential_type_id === "G1"
                    ? "UAT Credentials"
                    : item.credential_type_id === "B1"
                    ? "BAT Credentials"
                    : "Prod Credentials"}
                </Typography>
              }
            />
          );
        })}
        <UpdateButtonBox>
          <UpdateButton
            variant="contained"
            // disabled={!props.credentials.length}
            onClick={props.handleUpdateSubmit}
            sx={{ color: "white" }}
          >
            {state.onSubmitLoading && state.isformDataChange ? (
              <CircularProgress
                size={20}
                sx={{ color: "white" }}
              ></CircularProgress>
            ) : (
              "Save Updates"
            )}
          </UpdateButton>
        </UpdateButtonBox>

        <Arrow isMobile={props.isMobile} height={state.userEditBoxHeight} />
        <ArrowBorder
          isMobile={props.isMobile}
          height={state.userEditBoxHeight}
        />
      </ArrowBox>
    </UpdateFadeBox>
  );
});
